import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'truncate', standalone: true })
export class TruncatePipe implements PipeTransform {
    static truncate(value: string, limit: number) {
        if (value && value.length > limit) {
            return `${value.substring(0, limit)}...`;
        }

        return value;
    }

    transform(value: string, args?: any): string {
        const limit = args ? Number.parseInt(args, 10) : 200;

        return TruncatePipe.truncate(value, limit);
    }
}
